import p from './device-manage-log.vue';

export default p;
